// eslint-disable-next-line
import { http } from '../api';

function getOrgId(method) {
  var orgId = window.localStorage.orgId || '';

  if (!orgId) {
    console.warn('登录成功后 userInfo 的字段都会被写入localStorage，包含 orgId, 用 orgId 查 corpid, 然后初始化SDK...');
    console.error(method + ": localStorage.orgId \u4E3A\u7A7A");
    return false;
  }

  return orgId;
}

export var loadConfig = function loadConfig(type, url, orgid) {
  var orgId = orgid || getOrgId('loadConfig');
  if (!orgId) return Promise.resolve(false);
  var token = localStorage.token || '';
  return http.orgInit.post('/wx/corp/jsconfig', {
    orgId: orgId,
    type: type,
    url: url,
    token: token
  }, {
    headers: {
      token: token
    }
  });
};
export var getCorpId = function getCorpId(orgid) {
  var orgId = orgid || getOrgId('getCorpId');
  if (!orgId) return Promise.resolve(false);
  var token = localStorage.token || '';
  return http.orgInit.get('/dingding/corpid', {
    orgId: orgId,
    token: token
  }, {
    headers: {
      token: token
    }
  });
};
export var getTicketAndGroup = function getTicketAndGroup() {
  return http.core.get('/auth/ticket');
};